var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTravelSvgrepoCom1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3061_7075)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 4.125V3.5C10.5 3.16848 10.3683 2.85054 10.1339 2.61612C9.89946 2.3817 9.58152 2.25 9.25 2.25H6.75C6.41848 2.25 6.10054 2.3817 5.86612 2.61612C5.6317 2.85054 5.5 3.16848 5.5 3.5V4.125C4.83696 4.125 4.20107 4.38839 3.73223 4.85723C3.26339 5.32607 3 5.96196 3 6.625V13.5C3 13.8315 3.1317 14.1495 3.36612 14.3839C3.60054 14.6183 3.91848 14.75 4.25 14.75H11.75C12.0815 14.75 12.3995 14.6183 12.6339 14.3839C12.8683 14.1495 13 13.8315 13 13.5V6.625C13 5.96196 12.7366 5.32607 12.2678 4.85723C11.7989 4.38839 11.163 4.125 10.5 4.125ZM6.75 3.5H9.25V4.125H6.75V3.5ZM8 6.625L9.25 7.875L8 9.125L6.75 7.875L8 6.625ZM11.75 11H6.125V12.25H5.5V11H4.25V10.375H11.75V11Z",
    fill: "#321E5D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3061_7075"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.3616,
    height: 15.3616,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTravelSvgrepoCom1);
export default __webpack_public_path__ + "static/media/travel-svgrepo-com (1).e348a8334571cb9ee5222a65472cf2c8.svg";
export { ForwardRef as ReactComponent };